<template>
    <div>
            <b-form>
                <div class="animated fadeIn">
                    <b-row>
                        <b-col md="12">
                            <b-form-group
                            description=""
                            label="Atendimento"
                            label-for="historyDetail"
                            :label-cols="3"
                            :horizontal="false">
                                
                            <b-form-textarea
                                    id="historyDetail"
                                    v-model="historyDetail"
                                    rows="3"
                                    :class="historyDetailClass"
                            ></b-form-textarea>
                            
                            </b-form-group>          
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12">
                        <b-form>
                            <b-form-group
                                description=""
                                label="Status"
                                label-for="historyStatus"
                                :label-cols="3"
                                :horizontal="true">
                                <b-form-select id="historyStatus"
                                    v-model="statusId"
                                    :plain="true"
                                    :options="statusDDL"
                                    value=""
                                    :disabled="componentItem.statusId == 3"
                                    >
                                </b-form-select>
                                
                            </b-form-group>
                        </b-form>
                        </b-col>
                    </b-row>

                    <div v-show="statusId == 3">
                        <hr>
                        <b-row>
                            <b-col md="12">
                                <b-form-group
                                description=""
                                label="Valor do contrato / inscrição"
                                label-for="referralValue"
                                :label-cols="3"
                                :horizontal="false">
                                <b-row>
                                    <b-col sm="4">
                                        <b-form-input v-model="referralValue" id="referralValue" type="number"></b-form-input>
                                    </b-col>
                                    <b-col sm="4">
                                        Início do contrato
                                    </b-col>
                                    <b-col sm="4">
                                        <b-form-input v-model="referralDate" id="referralDate" type="date"></b-form-input>
                                    </b-col>
                                </b-row>
                                </b-form-group>          
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col md="12">
                                <b-form-group
                                description=""
                                label="Valor da mensalidade"
                                label-for="monthlyValue"
                                :label-cols="3"
                                :horizontal="false">
                                <b-row>
                                    <b-col sm="4">
                                        <b-form-input v-model="monthlyValue" id="monthlyValue" type="number"></b-form-input>
                                    </b-col>
                                    <b-col sm="4">
                                        Primeira mensalidade
                                    </b-col>
                                    <b-col sm="4">
                                        <b-form-input v-model="monthlyDate" id="monthlyDate" type="date"></b-form-input>
                                    </b-col>
                                </b-row>
                                </b-form-group>          
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col md="12">
                                <b-form-group
                                description=""
                                label="Dia de pagamento"
                                label-for="monthlyPaymentDay"
                                :label-cols="3"
                                :horizontal="false">
                                <b-row>
                                    <b-col sm="2">
                                        <b-form-input v-model="monthlyPaymentDay" id="monthlyPaymentDay" min="1" max="3" type="number"></b-form-input>
                                    </b-col>
                                </b-row>
                                </b-form-group>          
                            </b-col>
                        </b-row>
                    </div>    

                </div>
            </b-form>

            <div slot="footer" class="text-right">
                    <!--
                    <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.componentItem.id && this.componentItem.st=='I'"><i class="fa fa-times"></i><span>Habilitar</span></b-button>
                    <b-button variant="html5" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.componentItem.id && this.componentItem.st=='A'"><i class="fa fa-times"></i><span>Desabilitar</span></b-button>
                    -->
                    <b-button variant="github" class="mr-1 btn-brand" @click="save()" :disabled="saving || componentItem.statusId == 3"><i class="fa fa-check"></i><span>Salvar Atendimento</span></b-button>                    
            </div>

            <p></p>

            
            <b-table
            :items="historyItems"
            :fields="table.fields"
            :select-mode="table.selectMode"
            responsive="sm"
            ref="selectableTable"
            selectable
            :primary-key="table.primaryKey"
            :tbody-transition-props="table.transProps"
            sort-icon-left
            :per-page="table.perPage"
            :current-page="table.currentPage"
            :busy="table.isBusy"
            hover
            striped
            sticky-header: true
            >

                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                </template>
                
                <!-- Example scoped slot for select state illustrative purposes -->
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                    </template>
                </template>

                <template v-slot:cell(createdIn)="data">
                    {{ $utils.localDateShortTime(data.item.createdIn) }}
                </template>

                <template v-slot:cell(historyDetail)="data">
                    {{ data.item.historyDetail }}<br>
                    <span class="text-muted small">Atendido por: {{ data.item.userName }}</span>
                </template>

                <template v-slot:cell(st)="data">
                    <c-switch class="" @change.native="changeStatus(data.item)" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
                <template v-slot:cell(ispublic)="data">
                    <c-switch class="" color="primary" :checked="data.item.ispublic==1" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
            </b-table>
    </div>  

</template>


<script>
import Vue from 'vue'
import axios from "axios";
import MaskedInput from 'vue-text-mask'

/* Toast */
import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
import { BIconTelephoneMinus } from 'bootstrap-vue';
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */

export default {
    name: 'documentTemplatePdfComponent',
    props: {
       item: {},
       companyId: 0
    },
    components: {
      MaskedInput
    },
    data: () => {
        return {
            saving: false,
            referralValue: '',
            referralDate: null,
            monthlyValue: '',
            monthlyPaymentDay: '',
            monthlyDate: null, 
            historyDetail: '',
            historyDetailClass: '',
            statusId: 0,
            statusDDL: [],

            historyItems: [],
            table: {
                fields: [
                    {key: 'createdIn', label: 'Data', sortable: true, thStyle: { width: "140px" }  },
                    {key: 'historyDetail', label: 'Histórico de Atendimento', sortable: true  },
                    {key: 'status.name', label: 'Status', sortable: true, class: 'text-center', thStyle: { width: "150px" } },
                ],
                sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                currentPage: 1,
                perPage: 20,
                isBusy: false,
                modes: ['multi', 'single', 'range'],
                selectMode: 'multi',
                primaryKey: "id",
                transProps: {
                name: 'flip-list'
                }
           }
        }
    },
    computed: {

        componentItem() {
            return this.item
        }
    },
    methods: {
        save() {
            var containsError = false

            if(!this.historyDetail || this.historyDetail.length <= 0) {
                this.historyDetailClass="is-invalid"
                containsError = true
            }
            else {
                this.historyDetailClass=""
            }

            if(!containsError) {                
                this.saveItem(this.componentItem);
            }
        },
        
        async saveItem(currentItem) {

            var s = this;
            var postData = {};

            s.saving = true

            postData["referralId"] = this.componentItem.id
            postData["statusId"] = this.statusId

            postData["historyDetail"] = this.historyDetail

            postData["referralValue"] = this.referralValue ? this.referralValue.replace(",",".") : null
            postData["referralDate"] = this.referralDate

            postData["monthlyValue"] = this.monthlyValue ? this.monthlyValue.replace(",", ".") : null
            postData["monthlyPaymentDay"] = this.paymentDay
            postData["monthlyDate"] = this.monthlyDate


            postData["uid"] = this.$store.state.currentUser.id
            postData["sid"] = this.$store.state.currentUser.sid

            console.log(postData)
            
            await axios.post(
                this.$store.state.ws_url + "/franchise/referral/history",
                postData
            ).then(function() {
                s.$emit('resp', { code: 1, message: 'Histórico alterado com sucesso.'})
                s.saving = false
            }
            ).catch(function (error) {
                console.log(error);
                s.saving = false

                toast ({
                    type: VueNotifications.types.warn,
                    title: 'Histórico',
                    message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
                    timeout: 5000
                })        
            });
            
        },

        async getStatus() {
            var s = this;
            var currentUser = this.$store.state.currentUser;
            await axios.get(
                this.$store.state.ws_url + "/franchise/referral/status/ddl?uid=" + currentUser.id + "&sid=" + currentUser.sid
            )
            .then(function(resp) {
                s.statusDDL = resp.data.obj
            }).catch(function(error) {                
                console.log(error)
            })
        },

        async refreshHistory() {
            
            var s = this;
            var currentUser = this.$store.state.currentUser;
            
            await axios.get(
                this.$store.state.ws_url + "/franchise/referral/history?referralId=" + s.componentItem.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function (resp) {
                s.historyItems = resp.data.obj;
            }).catch(function (error) {
                console.log("ERRO")
                console.log(error.message);                
            });
        
        }
        
       
    },
    mounted: function() {
        this.getStatus()  
        this.refreshHistory()
        this.statusId = this.componentItem.statusId
        this.referralValue = this.componentItem.referralValue
        this.referralDate = this.componentItem.referralDate
        this.monthlyValue = this.componentItem.monthlyValue
        this.monthlyDate = this.componentItem.monthlyDate
        this.paymentDay = this.componentItem.monthlyPaymentDay
    }
}
</script>